import { render } from "./features_panel.vue?vue&type=template&id=b70692d6"
import script from "./features_panel.js?vue&type=script&lang=js"
export * from "./features_panel.js?vue&type=script&lang=js"

import "./features_panel.vue?vue&type=style&index=0&id=b70692d6&lang=scss"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__